import { Navigate } from 'react-router-dom'

import AuthGuard from '../../auth/AuthGuard'
import MatxLayout from '../base/components/Template/MatxLayout/MatxLayout'
import cuentaRoutes from '../modules/base/cuenta/CuentaRoutes'
import NotFound from '../modules/base/sessions/NotFound'
import sessionRoutes from '../modules/base/sessions/SessionRoutes'
import ventasRoutes from '../modules/ventas/VentasRoutes'
import productosRoutes from '../modules/productos/ProductosRoutes'
import clientesRoutes from '../modules/clientes/ClientesRoutes'
import proveedorRoutes from '../modules/proveedor/ProveedorRoutes'
import notaCreditoDebitoRoutes from '../modules/notaCreditoDebito/NotaCreditoDebitoRoutes'
import homeRoutes, { homeRoutesMap } from '../modules/home/HomeRoutes'
import contingenciaRoutes from '../modules/contingencia/ContingenciaRoutes'
import ventaOfflineRoutes from '../modules/ventaOffline/VentaOfflineRoutes'
import eventosRoutes from '../modules/eventos/EventosRoutes'

export const appRoutes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...homeRoutes,
      ...ventasRoutes,
      ...productosRoutes,
      ...clientesRoutes,
      ...cuentaRoutes,
      ...proveedorRoutes,
      ...notaCreditoDebitoRoutes,
      ...contingenciaRoutes,
      ...ventaOfflineRoutes,
      ...eventosRoutes,
    ],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to={homeRoutesMap.home.path} /> },
  { path: '*', element: <NotFound /> },
]
